import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion'

const ReadingProgress = ({ target = null }) => {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const calculateProgress = () => {
      let scrollTop, scrollHeight, clientHeight

      if (target) {
        // Если указан конкретный элемент
        const element = typeof target === 'string' ? document.getElementById(target) : target
        if (!element) return

        const rect = element.getBoundingClientRect()
        const elementTop = rect.top + window.pageYOffset
        const elementHeight = element.scrollHeight || element.offsetHeight
        
        scrollTop = Math.max(0, window.pageYOffset - elementTop)
        scrollHeight = elementHeight
        clientHeight = window.innerHeight
      } else {
        // Для всей страницы
        scrollTop = window.pageYOffset
        scrollHeight = document.documentElement.scrollHeight - window.innerHeight
        clientHeight = window.innerHeight
      }

      if (scrollHeight <= 0) {
        setProgress(0)
        return
      }

      const scrolled = Math.min(100, (scrollTop / scrollHeight) * 100)
      setProgress(scrolled)
    }

    calculateProgress()
    window.addEventListener('scroll', calculateProgress, { passive: true })
    window.addEventListener('resize', calculateProgress, { passive: true })

    return () => {
      window.removeEventListener('scroll', calculateProgress)
      window.removeEventListener('resize', calculateProgress)
    }
  }, [target])

  return (
    <motion.div
      className="fixed top-0 left-0 right-0 z-50 h-1 bg-gray-200 dark:bg-gray-700"
      initial={{ scaleX: 0 }}
      animate={{ scaleX: 1 }}
    >
      <motion.div
        className="h-full bg-gradient-to-r from-blue-500 to-purple-600 origin-left"
        style={{ scaleX: progress / 100 }}
        transition={{ duration: 0.1 }}
      />
    </motion.div>
  )
}

export default ReadingProgress